import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  aside?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, aside }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="mb-2 flex items-center gap-2">
          <span className="h-4 w-1 rounded-full bg-primary-500" />
          <span className="font-label text-xs font-medium tracking-[0.22em] text-primary-700">
            {eyebrow}
          </span>
        </div>
        <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
          {title}
        </h3>
        {desc ? (
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{desc}</p>
        ) : null}
      </div>
      {aside ? <div className="shrink-0">{aside}</div> : null}
    </div>
  );
}